let section;
let form;
let fetchRoot;
let recaptchaInput;

const errorClass = 'has-error';

function clearError(e) {
    const errorNode = e.currentTarget.closest(`.${errorClass}`)
    if (errorNode) {
        errorNode.classList.remove(errorClass);
        const errorTextNode = errorNode.querySelector('.form-error');
        if (errorTextNode) {
            errorTextNode.parentNode.removeChild(errorTextNode)
        }
    }
}

function clearErrors() {
    form.querySelectorAll(`.${errorClass}`).forEach(node => {
        node.classList.remove(errorClass);
    })

    form.querySelectorAll('.form-error').forEach(node => {
        node.parentNode.removeChild(node)
    })
}

function handleChange() {
    const selected = section.querySelector('[data-condition-selector] input:checked')?.value;
    const conditionals = section.querySelectorAll('[data-conditional]');

    conditionals.forEach(el => {
        if (el.dataset.conditional === selected) {
            el.classList.remove('is-hidden');
        } else {
            el.classList.add('is-hidden');
        }
    });
}

async function handleSubmit(e) {
    e.preventDefault();

    const button = form.querySelector('button[type=submit]');
    button.setAttribute('disabled', true)
    const url = form.getAttribute('action');
    form.classList.add('is-loading')

    const recaptchaToken = await grecaptcha.enterprise.execute(form.dataset.recaptchaKey, {
        action: 'CONTACT_FORM_SUBMISSION'
    });
    recaptchaInput.value = recaptchaToken

    const formData = new FormData(form);

    const response = await fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json'
        },
    })

    const data = await response.json();

    if (data.html) {
        fetchRoot.innerHTML = data.html;
    } else {
        window.alert(data.message || 'Error Processing Form');

        // most likely csrf token has expired
        setTimeout(() => {
            window.location.reload();
        }, 2500);
    }

    section.classList.remove('is-loading');
    button.removeAttribute('disabled')

    if (!data.success) {
        init();
        handleChange();

        return;
    }

    // scroll success message into view
    fetchRoot.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    // trigger datalayer event (prod or debug mode only)
    if (window.dataLayer) {
        window.dataLayer.push({
            'event': 'form_submission_success',
            'form_name': 'contact_us_main',
            'lead_type': 'contact_inquiry'
        });
    }
}

function selectFromHash() {
    const hash = window.location.hash.replace('#', '');
    if (!hash) {
        return;
    }

    const hashInputLabel = form.querySelector(`[data-handle=${hash}] label`)
    if (!hashInputLabel) {
        return;
    }

    hashInputLabel.click()
}

function init() {
    form = section.querySelector('form');
    recaptchaInput = form.querySelector('[data-recaptcha-input]');

    // no form on thank you page
    if (form) {
        form.addEventListener('change', handleChange);
        form.addEventListener('submit', handleSubmit)

        form.querySelectorAll('input, textArea, select').forEach(node => {
            node.addEventListener('blur', clearError)
        })

        // clear errors on form type change
        form.querySelectorAll('[data-condition-selector]').forEach((selector) => {
            selector.addEventListener('click', clearErrors)
        })
    }
}

export default function SectionContactForm(el) {
    section = el;
    fetchRoot = el.querySelector('[data-fetch-root]');

    init();
    handleChange();
    selectFromHash();
}
